module.exports = __webpack_public_path__ + "img/gbyte.e58a6b87.svg";